export const FETCH_BANNERLIST_REQUEST = 'FETCH_BANNERLIST_REQUEST'
export const FETCH_BANNERLIST_SUCCESS = 'FETCH_BANNERLIST_SUCCESS'
export const FETCH_BANNERLIST_FAILURE = 'FETCH_BANNERLIST_FAILURE'
